module.exports = __webpack_public_path__ + "static/media/cloud-c2-v3@2x.927bb0e6.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/cloud-c2-v3@2x.png
// module id = 97
// module chunks = 0